// extracted by mini-css-extract-plugin
export default {"main":"PasswordResetView_main__saA2i"};